import React from 'react';
import './Loading.scss';

export default ()=> {
    return (
        <div className="m-loading">
            <div></div>
            <div></div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/common/components/loading/Loading.jsx